module.exports = __webpack_public_path__ + "7864a9beaf16f56ffaacfe7ce38b1202.png";